import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';

export type CompanyUpdateRequest = {
  company: {
    industry?: string;
    postal_code?: string;
    prefecture_code?: string;
    address?: string;
    family_name?: string;
    first_name?: string;
    family_name_kana?: string;
    first_name_kana?: string;
    birthday?: string;
    establishment_year?: string;
    fiscal_month?: string;
    service_description?: string;
    revenus_scale?: string;
    employee_scale?: string;
  };
};
export type CompanyUpdateResponse = unknown;

export type CompanyUpdateErrorResponse = {
  company: {
    name: string[];
    name_kana: string[];
    industry: string[];
    postal_code: string[];
    prefecture_code: string[];
    address: string[];
    family_name: string[];
    first_name: string[];
    family_name_kana: string[];
    first_name_kana: string[];
    birthday: string[];
    establishment_year: string[];
    fiscal_month: string[];
    service_description: string[];
    revenus_scale: string[];
    employee_scale: string[];
  };
};

export const companyUpdateApiClient = {
  update: async (
    id: number,
    params: CompanyUpdateRequest,
  ): Promise<ApiResult<CompanyUpdateResponse, CompanyUpdateErrorResponse>> => {
    return await axiosClient.put(`/company/companies/${id}`, params);
  },
};
